import { ThemeOptions } from "@mui/material";

declare module '@mui/material/styles' {
  interface Theme {
    daPalette: {
      black: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      blue: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      orange: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      green: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      yellow: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      greyBlue: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      darkBlue: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      grey: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      lightGrey: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
      darkGrey: {
        main: string,
        light: string,
        dark: string,
        contrastText: string,
      },
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    daPalette?: {
      black?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      blue?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      orange?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      green?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      yellow?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      greyBlue?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      darkBlue?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      grey?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      lightGrey?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
      darkGrey?: {
        main: string,
        light?: string,
        dark?: string,
        contrastText?: string,
      },
    };
  }
}

export const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#00A0DC',
      light: '#33B3E3',
      dark: '#00709A',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F50057',
      light: '#F73378',
      dark: '#AB003C',
      contrastText: '#ffffff',
    },
  },
  typography: {
    h1: {
      fontFamily: 'Poppins, sans-serif',
      fontSize: '3.1875rem',
      fontWeight: 600,
      letterSpacing: '-.5px',
    },
    h2: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: '2.375rem',
      lineHeight: 1.3,
      letterSpacing: '-.5px',
    },
    h3: {
      fontFamily: 'Poppins, sans-serif',
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
      letterSpacing: '-.5px',
    },
    h4: {
      fontFamily: 'Poppins, sans-serif',
      fontSize: '1.3125rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: 'Poppins, sans-serif',
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h6: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '1.3125rem',
      fontWeight: 500,
      lineHeight: 1.3,
      letterSpacing: '-.05px',
    },
    subtitle1: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '1.3125rem',
      fontWeight: 300,
      lineHeight: 1.2,
    },
    subtitle2: {
      fontFamily: 'Oswald',
      fontSize: '1rem',
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
    },
  },
  daPalette: {
    black: {
      main: '#221f20',
      light: '#4E4B4C',
      dark: '#171516',
      contrastText: '#ffffff',
    },
    blue: {
      main: '#00A0DC',
      light: '#61d1ff',
      dark: '#0072aa',
      contrastText: '#ffffff',
    },
    orange: {
      main: '#f48056',
      light: '#ffb184',
      dark: '#bc512b',
      contrastText: '#000000',
    },
    green: {
      main: '#39bb9d',
      light: '#73eece',
      dark: '#008a6f',
      contrastText: '#000000',
    },
    yellow: {
      main: '#fdb913',
      light: '#ffeb53',
      dark: '#c58900',
      contrastText: '#000000',
    },
    greyBlue: {
      main: '#6a7c90',
      light: '#99abc0',
      dark: '#3e5062',
      contrastText: '#000000',
    },
    darkBlue: {
      main: '#3c4456',
      light: '#676f83',
      dark: '#151d2d',
      contrastText: '#ffffff',
    },
    grey: { // Grey 500
      main: '#bdbdbd',
      light: '#dfdfdf',
      dark: '#868686',
      contrastText: '#000000',
    },
    lightGrey: { // Grey 200
      main: '#e0e0e0',
      light: '#e9e9e9',
      dark: '#acacac',
      contrastText: '#000000',
    },
    darkGrey: { // Grey 700
      main: '#616161',
      light: '#868686',
      dark: '#3c3c3c',
      contrastText: '#ffffff',
    },
  },
};
